import React from 'react';
import PropTypes from 'prop-types';
import {Image} from '@learningblocks/shared-components';
import {
  MCFrontEmptyIcon as MC_OPEN,
  MCFrontClosedIcon as MC_CLOSED,
} from '../../../Icons';

export function MicroImage(props) {
  const getImage = () => (props.isOpen ? MC_OPEN : MC_CLOSED);

  return (
    <div className='microcentrifuge__image'>
      <Image src={getImage()} alt='microcentrifuge_image' />
    </div>
  );
}

MicroImage.propTypes = {
  /**
   * Boolean to set if apparatus is open/closed
   */
  isOpen: PropTypes.bool,
  /**
   * function to invoke when Image is clicked
   */
  onSelect: PropTypes.func,
};

MicroImage.defaultProps = {};
